import { RefObject } from 'react';
import { CommonFormField } from '../../../../components/Form/CommonFormField';
import {
  TextAttributeInput,
  TextAttributeInputProps,
} from '../../../../components/HeadlessComponents/TextAttributeInput';

export type TextAttributeFieldProps = Omit<TextAttributeInputProps, 'error'> & {
  required?: boolean;
  error?: string;
  fieldRef?: RefObject<HTMLDivElement>;
};

/**
 * Layer B: composes `CommonFormField` (label, asterisk for `required`, inline
 * `error` message) around `TextAttributeInput`. Matches the
 * `PureEnumMultiDropdownField` pattern used elsewhere in the lib.
 *
 * `required` (asterisk) and `error` (inline message string) are decoupled from
 * any specific validation source — Formik schemas, dynamic mandatory pipelines,
 * or hand-rolled checks can all drive them.
 */
export const TextAttributeField = ({
  attribute,
  required,
  error,
  fieldRef,
  ...inputProps
}: TextAttributeFieldProps) => (
  <CommonFormField label={attribute.displayName} required={required} error={error} ref={fieldRef}>
    <TextAttributeInput attribute={attribute} {...inputProps} error={!!error} />
  </CommonFormField>
);
